import React, { useState } from 'react';
import Accordion from '../../../../components/Accordion';
import Icon from '../../../../components/Icons';
import InputInfo from '../../../../components/Inputs/Info';
import * as S from './styles';
import Checkbox from '../../../../components/Inputs/Checkbox';

export function useDependentsList(dependentsList) {
    const [dependents, setDependents] = useState(dependentsList.map(dep => ({...dep, emitidoPor: "C", checked: false})));
    const [isCongenerExclusive, setIsCongenerExclusive] = useState(true);

    const options = isCongenerExclusive 
    ? [{value: 'C', title: 'Congênere'}]
    : [
        {value: 'A', title: 'Ambas'},
        {value: 'C', title: 'Congênere'},
        {value: 'O', title: 'GNDI'},
    ]

    function handleChangeIssuedBy(value, dependent) {
        const newDependentsList = dependents.map(element => 
            element.numCarteirinha === dependent.numCarteirinha
                ? {...element, emitidoPor: value}
                : element
        );
        setDependents(newDependentsList);
    }

    function handleCheckboxClick(dependent) {
        const newDependentsList = dependents.map(element => 
            element.numCarteirinha === dependent.numCarteirinha
                ? {...element, checked: !dependent.checked }
                : element
        );
        setDependents(newDependentsList);
    }

    function renderDependentsListItem(dependent) {
        return (
            <S.ContainerCheckboxLabel key={dependent.numCarteirinha}>
                <S.CheckboxWrapper>
                    <Checkbox checked={dependent.checked} onClick={() => handleCheckboxClick(dependent)}/>
                </S.CheckboxWrapper>
                <InputInfo
                    field={{
                        id: 'numCarteirinha',
                        label: 'Nº da carteirinha',
                        value: `${dependent.numCarteirinha}`,
                    }}
                />
                <InputInfo
                    field={{
                        id: 'nome',
                        label: 'Nome completo',
                        value: `${dependent.nomeCompleto}`,
                    }}
                />
                <InputInfo
                    field={{
                        id: 'parentesco',
                        label: 'Grau de parentesco',
                        value: `${dependent.dependencia.nome}`,
                    }}
                />  
                <S.IssuedByWrapper>
                    <S.LabelWrapper>
                        <label htmlFor="issuedBy">Emitido por:</label>
                        <Icon name="ArrowDown" color="#EC130F"/>
                    </S.LabelWrapper>
                    {/* eslint-disable-next-line no-restricted-globals */}
                    <S.IssuedBySelect disabled={isCongenerExclusive} name="issuedBy" onChange={() => handleChangeIssuedBy(event.target.value, dependent)} selected={dependent.issuedBy}>
                        {options.map(opt => <option value={opt.value}>{opt.title}</option>)}
                    </S.IssuedBySelect>
                </S.IssuedByWrapper>
            </S.ContainerCheckboxLabel>
        );
    }

    function renderDependentsList() {
        return dependents.length ? (
            <S.Pannel>
                <Accordion title="Solicitar segunda via para dependentes" hasCollapse={false}>
                    {dependents.map(dependent => renderDependentsListItem(dependent))}
                </Accordion>
            </S.Pannel>
        ) : <></>
    }

    return [renderDependentsList, dependents, setIsCongenerExclusive];
}